module.exports = __webpack_public_path__ + "static/media/logo-cigam.573ae127.svg";